import { notify } from '@/utils/useNotifications'
import axios, { AxiosError } from 'axios'
import { userService } from '@/services/User.service'

const DEFAULT_ERR_MSG = 'Something went wrong'

class ApiError extends Error {}

const errorHandler = (error: AxiosError | Error) => {
  let message: string | null = null

  if (axios.isAxiosError(error) && error instanceof AxiosError) {
    // Only an unauthenticated/invalidated session (401) ends the session. A 403
    // means the user is validly signed in but lacks permission for this action —
    // surface the message and keep them where they are.
    if (error.response?.status === 401) {
      userService.logout(false)
      location.href = '/'
    }
    if (error.response) {
      const data = error.response.data
      const errors = data.errors
      const body = data.data?.body

      message = errors
      if (body) message += `<br>${body}`
    }
  } else {
    message = error.message
  }
  message = message ?? DEFAULT_ERR_MSG

  notify(message, 'danger')
  throw new ApiError(message)
}

export { errorHandler, ApiError }
